import React, { useState } from 'react'

import { type UserGroupName } from '../api/interfaces/sconnStudyData'
import EditNicknameModal from '../components/EditNicknameModal'
import EditSurveyFormModal from '../components/EditSurveyFormModal'
import MyAccountSetting from '../components/myAccountSettingLayout'
import { useBookcafeData } from '../module/myPage/hook'
import { useNativeInteractor } from '../module/nativeInteractor/context'
import { useSurveySteps } from '../module/survey/hook'
import { type SurveyStep } from '../module/survey/types'

const USER_GROUP_LABEL: Record<UserGroupName, string> = {
  university: '대학생',
  repeat_applicant: 'N수생/반수생',
  general: '일반인',
  high_school: '고등학생',
  middle_school: '중학생',
  elementary: '초등학생',
}

function formatUserGroup(userGroup: UserGroupName, grade: number | null | undefined) {
  const label = USER_GROUP_LABEL[userGroup]
  return grade != null ? `${label} ${grade}학년` : label
}

export default function MyBookcafeAccount() {
  const { user } = useBookcafeData()
  const { interactor } = useNativeInteractor()
  const { setSkipLastStep } = useSurveySteps()
  const [editStep, setEditStep] = useState<SurveyStep>('userGroup')
  const [openEditSurveyModal, setOpenEditSurveyModal] = useState<boolean>(false)
  const [openEditNicknameModal, setOpenEditNicknameModal] = useState<boolean>(false)

  const learningGoals = [
    ...(user?.examCustomNames ?? []),
    ...(user?.examKeywords?.map((keyword) => keyword.name) ?? []),
  ].join(', ')

  const handleLogout = () => {
    console.log('logout')
    interactor.serviceLogout()
  }

  return (
    <MyAccountSetting>
      <MyAccountSetting.Header />
      <MyAccountSetting.Contents title='계정 정보'>
        <MyAccountSetting.ContentsRow title='이메일'>
          <span className='text-sub-font'>{user?.email}</span>
        </MyAccountSetting.ContentsRow>
        <MyAccountSetting.ContentsRow
          title='닉네임'
          // visible={user?.nickName !== user?.email}
          editable
          onClickEdit={() => {
            setOpenEditNicknameModal(true)
          }}
        >
          {user?.nickName ?? ''}
        </MyAccountSetting.ContentsRow>
        <MyAccountSetting.ContentsRow
          title='MY 그룹'
          visible={user?.userGroup !== undefined && user?.userGroup !== null}
          editable
          onClickEdit={() => {
            setEditStep('userGroup')
            setSkipLastStep(false)
            setOpenEditSurveyModal(true)
          }}
        >
          {user?.userGroup && formatUserGroup(user.userGroup, user.userGroupGrade)}
        </MyAccountSetting.ContentsRow>
        <MyAccountSetting.ContentsRow
          title='MY 학습 목표'
          visible={learningGoals.length > 0}
          editable
          onClickEdit={() => {
            setEditStep('examinations')
            setSkipLastStep(user?.userGroup !== 'university')
            setOpenEditSurveyModal(true)
          }}
        >
          <span className='line-clamp-2'>{learningGoals}</span>
        </MyAccountSetting.ContentsRow>
        <MyAccountSetting.ContentsRow title='로그아웃' onClickTitle={handleLogout} />
        <MyAccountSetting.Extensions>
          <EditNicknameModal
            open={openEditNicknameModal}
            onClose={() => {
              setOpenEditNicknameModal(false)
            }}
          />
          <EditSurveyFormModal
            open={openEditSurveyModal}
            editStep={editStep}
            onCancel={() => {
              setOpenEditSurveyModal(false)
            }}
          />
        </MyAccountSetting.Extensions>
      </MyAccountSetting.Contents>
    </MyAccountSetting>
  )
}
